export enum DatepickerEvent {
  TODAY_BUTTON_CLICKED = 'todayButtonClicked'
}
